const PASSWORD_MIN_LENGTH = 8

export  const ruleRequired = (v:string,error:string="Ce champs est requis") => {
  return !!v || error
}

export const ruleMinLength = (v:string,length:number,fieldName='Le champs') => {
  return v.length >= length || `${fieldName} doit posséder au moins ${length} caractères`
}

export const rulePasswordMinLength = (v:string) => {
  return ruleMinLength(v,PASSWORD_MIN_LENGTH,'Le mot de passe')
}

export const ruleMatch = (v:string,verif:string,fieldName='Les champs') => {    
  return verif == v || `${fieldName} doivent correspondre`   
}

export const ruleMailMatch = (v:string,verifMail:string) => {    
  return ruleMatch(v,verifMail,'Les emails')
}

export const rulePasswordMatch = (v:string,verifPass:string) => {    
  return ruleMatch(v,verifPass,'Les mots de passe')
}

export const ruleMailValid = (v:string) => {    
  return /(.+)@(.+){2,}\.(.+){2,}/.test(v) || "Le format de l'email est invalide"
}